import React, { useReducer, useState, useEffect } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Form,
  Input,
  Checkbox,
  Button,
  notification,
  Select,
} from "antd";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
const { Option } = Select;
const NewVehicle = () => {
  const [form] = Form.useForm();
  const [logischeckedValues, setlogischeckedValues] = useState("");
  const [checkedValues, setcheckedValues] = useState("");
  const [transport, settransport] = useState([""]);
  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      logistics_type: "",
      vehicle_type: "",
      vehicle_number: "",
      t_id: "",
      load_capacity: "",
    }
  );

  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };

  function selecthandleChange(value) {
    setcheckedValues(value);
  }
  function handleChangeNew(checkedValues) {
    setlogischeckedValues(checkedValues.toString());
  }

  const openNotification = (type) => {
    notification[type]({
      message: "Vehicle Added",
      description: "Vehicle added successfully",
    });
  };
  const FailNotification = (type) => {
    notification[type]({
      message: "Error",
      description: "Please Fill out Required Fields",
    });
  };
  const onhandleSubmit = () => {
    userInput.logistics_type = logischeckedValues;
    userInput.t_id = checkedValues;
    // console.log(userInput);
    if (userInput.vehicle_type !== "") {
      axios
        .post(`${getServerUrl()}/master/createvehicle`, userInput, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        })
        .then((res) => {
          const data = res.data;
          //console.log(data);
          if (data.success === 1) {
            setUserInput({
              logistics_type: "",
              vehicle_type: "",
              vehicle_number: "",
              load_capacity: "",
              t_id: "",
            });
            form.resetFields();
            openNotification("success");
          } else {
          }
        });
    } else {
      FailNotification("error");
    }
  };
  const onReset = () => {
    form.resetFields();
  };
  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/transport`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        settransport(details);
      });
  }, []);
  const dropDownOptions = transport.map((dataDrop) => {
    return <Option value={dataDrop.t_id}>{dataDrop.transporter_name}</Option>;
  });

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
        <Breadcrumb.Item>Transport Settings</Breadcrumb.Item>
        <Breadcrumb.Item>Create New Vechicle</Breadcrumb.Item>
      </Breadcrumb>

      <div className="site-layout-background">
        <h2 className="titles">
          ADD NEW <span>VEHICLE</span>
        </h2>
        <Row>
          <Col span={16}>
            <h2>Vehicle</h2>
            <label>Vehicle Type</label>
            <Input
              name="vehicle_type"
              value={userInput.vehicle_type}
              onChange={handleChange}
            />
            <label>Vehicle Number</label>
            <Input
              name="vehicle_number"
              value={userInput.vehicle_number}
              onChange={handleChange}
            />
            <label>Transporter</label>
            <br></br>
            <Select
              name="raw_material_type"
              onChange={selecthandleChange}
              placeholder="Please Select Type"
              style={{ width: "250px" }}
            >
              {dropDownOptions}
            </Select>
            <br></br>
            <label>Load Capacity</label>
            <Input
              name="load_capacity"
              value={userInput.load_capacity}
              onChange={handleChange}
            />
            <label>Type of Logistics</label>
            <br></br>
            <Checkbox.Group
              name="logistics_type_label"
              onChange={handleChangeNew}
            >
              <Checkbox value="Internal Vendor Logistics">
                Internal Vendor Logistics
              </Checkbox>
              <Checkbox value="External Vendor Logistics">
                External Vendor Logistics
              </Checkbox>
            </Checkbox.Group>
            <br></br>
            <br></br>
            <Button
              type="primary"
              shape="round"
              htmlType="submit"
              size="large"
              onClick={onhandleSubmit}
            >
              Add Vehicle
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NewVehicle;
